import {Component, inject} from '@angular/core';

import {ModalService} from '../../../../services/modal.service';

/**
 * HTTP Error Modal Component
 * Displays network errors with optional technical details
 */
@Component({
  selector: 'app-http-error-modal',
  standalone: true,
  imports: [],
  templateUrl: './http-error-modal.component.html',
  styleUrl: './http-error-modal.component.scss'
})
export class HttpErrorModalComponent {
  private modalService = inject(ModalService);

  // Read-only signals from the modal service
  protected readonly showModal = this.modalService.showHttpErrorModal;
  protected readonly errorData = this.modalService.httpErrorData;
  protected readonly showErrorDetails = this.modalService.showErrorDetails;

  /**
   * Close the HTTP error modal
   */
  closeModal(): void {
    this.modalService.closeHttpErrorModal();
  }

  /**
   * Toggle the visibility of technical error details
   */
  toggleErrorDetails(): void {
    this.modalService.toggleErrorDetails();
  }
}
